module.exports = __webpack_public_path__ + "static/img/popup.e22f4d80.png";